import { render, staticRenderFns } from "./AdminEditView.vue?vue&type=template&id=4f720f6a"
import script from "./AdminEditView.vue?vue&type=script&lang=js"
export * from "./AdminEditView.vue?vue&type=script&lang=js"
import style0 from "./AdminEditView.vue?vue&type=style&index=0&id=4f720f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports